module.exports = __webpack_public_path__ + "static/media/gotlandvapen.e11eb8b7.png";